import { TranslationService } from '@ibk/shared-translation';
import { beneficiosTranslations } from './translations';
const translationService = new TranslationService(beneficiosTranslations);
export function activeBenefitCard(user) {
    return translationService.translate('benefits.card.activate', { user });
}
export function updateLanguage(language) {
    translationService.setLanguage(language);
}
export function getCurrentLanguage() {
    return translationService.getCurrentLanguage();
}
export { beneficiosTranslations } from './translations';
export { translationService };
export * from './enums';
export * from './pages';
export * from './hooks';
export * from './types';
export * from './components';
export * from './services/locationApi';
export * from './services/benefitApi';
export * from './utils/addressFormatter';
export * from './hooks/useBenefitContract';
export * from './hooks/useHasRecharges';
export * from './hooks/useWelcomeModalWithRecharges';
export * from './utils/contractStatusUtils';
export * from './utils/beneficiaryUtils';
